export default "__VITE_ASSET__DuJz$a1f__"